var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuMarketing = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  baseProfile: "tiny",
  id: "Marketing_1_",
  x: "0px",
  y: "0px",
  viewBox: "0 0 24 24",
  overflow: "visible",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "#FFFFFF",
  d: "M24,19.45L9.83,14l-0.57,0l2,9H5.21l-2.03-9.12c-1.14-0.33-2.17-1.4-2.17-2.88V8 c0-1.6,1.31-3,3-3h5.85L24,0.65V19.45z M6.82,21h1.95l-1.56-7H5.26L6.82,21z M9.01,7l-5,0c-0.51,0-1,0.43-1,1v3c0,0.51,0.43,1,1,1 l5,0V7z M11.01,6.74v5.58l11,4.23V3.35L11.01,6.74z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuMarketing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_Marketing.8b36ddc6.svg";
export { ForwardRef as ReactComponent };